module.exports = __webpack_public_path__ + "static/media/classic.06f4529a.jpg";